import styled from 'styled-components';
import pencil from 'assets/img/pencil2.svg';

export const Container = styled.div`
  display: flex;
  height: 80vh;
  width: 88.5vw;

  flex-direction: row;
  border-radius: 10px;
  background: #fff;
  margin: 10px 20px 20px 20px;
  box-shadow: -1px 0px 0px #eeeeee;
`;

export const TitlePage = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize || '22px'};
  line-height: 28px;

  color: #565656;
  width: 100%;
  padding-left: 20px;
  margin-top: 20px;
`;

export const ContainerUser = styled.div`
  border-right: 1px solid #eeee;
  height: 100%;
  width: 64%;
  display: flex;
  flex-direction: column;
`;

export const ContentProfile = styled.div`
  display: flex;
`;

export const ContainerPassword = styled.div`
  width: 36%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 0px 25px 0px;

  div {
    padding-right: 20px;
    padding-bottom: 40px;
    border-bottom: 1px solid #eeeeee;
    p {
      font-family: 'Roboto', sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 21px;
      margin-top: 20px;
      margin-bottom: 0px;
      margin-left: 20px;
      width: 100%;
      color: #565656;
      span {
        color: #ff6600;
        cursor: pointer;
      }
    }
  }
`;

export const ContentProfileUser = styled.div`
  margin: 8vh 2.5vw 7.5vh 5vw;
  display: flex;
  width: 20vh;
  height: 20vh;
`;

export const ImageUser = styled.div`
  background: url(${({ src }) => src}) no-repeat;
  height: 18vh;
  width: 18vh;
  border-radius: 50%;
  background-size: cover;
  border: 1px dashed #a8a2a2;
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
`;

export const EditImage = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  height: 19vh;
  input {
    cursor: pointer;
    margin-left: -5vh;
    margin-bottom: 2.5vh;
    background: url(${pencil}) no-repeat center;
    background-size: 4vh 4vh;
    background-color: #ff6600;
    width: 2vw;
    height: 2vw;
    border-radius: 50%;

    overflow: hidden;
    padding: 4.5vh 4.5vh 0 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
`;

export const ContentUserName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 8vh 5vw 7.5vh 0vw;
  width: 100%;
  height: 17vh;

  h2 {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;

    color: #565656;
  }

  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */

    color: #565656;
  }
`;

export const FormStyled = styled.form`
  display: flex;
  padding-left: 5vw;
  margin-top: 10px;
  width: 100%;
  flex-direction: column;
`;

export const RowFields = styled.div`
  display: flex;
  width: 100%;
  padding-right: 20px;
  height: 50px;
  margin-bottom: 29px;
  position: relative;
`;

export const ContentFields = styled.div`
  display: flex;
  flex-direction: column;
  height: 50px;
  margin-right: 20px;
  width: ${({ width }) => width || '16.66vw'};
`;

export const Label = styled.label`
  font-family: 'Roboto', sans-serif;
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  margin: 0;

  display: flex;
  align-items: center;

  color: #ff6600;
  width: 100%;
`;

export const Input = styled.input`
  border: 0 none;
  border-bottom: 1px solid #e8e8e8;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  width: 100%;
  color: #565656;

  :focus {
    border-bottom: 1px solid #ff6600;
  }
`;

export const ReceiveEmails = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: italic;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  margin-top: -3px;
  color: #565656;
`;

export const ImgStyled = styled.img`
  margin-left: 7px;
  margin-right: 7px;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const BtnSubmit = styled.button`
  border: none;
  outline: inherit;
  background: ${({ disabled }) => (disabled ? '#DCDCDC' : '#ff6600')};
  border-radius: 5px;

  width: 204px;
  height: 40px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  color: #fff;
`;

export const Tooltip = styled.div`
  display: ${({ open }) => (open ? '' : 'none')};
  position: absolute;
  width: 243px;
  height: 87px;
  left: 250px;
  top: -23px;

  background: #565656;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.49);
  border-radius: 5px;
  
  font-family: 'Roboto', sans-serif;
  font-style: italic;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  /* or 171% */
  padding: 7px 10px 7px 12px;
  color: #ffffff;
  z-index: 3;
  span {

    z-index: 12;
    position: absolute;
    left: -30px;
    top: 20px;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 15px solid transparent;
    border-right: 15px solid #565656
  }

  b {
    font-weight: 700;
  }
`;
